import CreatorEditCollectionPage from "./CreatorEditCollectionPage";

export default CreatorEditCollectionPage;